//#region ../icons/dist/html/compat/speed.js
const speedIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" fill=\"none\" aria-hidden=\"true\" viewBox=\"0 0 18 18\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M2.244 7.194A7 7 0 0 0 2 9a7 7 0 1 0 7-7c-.626 0-1.229.09-1.806.244M9 9 4 4\"/><circle cx=\"9\" cy=\"9\" r=\"1\" fill=\"currentColor\"/></svg>";
//#endregion
export { speedIcon };

//# sourceMappingURL=speed.js.map